import { BrowserRouter as Router, Routes, Route } from "react-router";
import ErrorBoundary from "./components/common/ErrorBoundary";
import AnalyticsWrapper from "./components/analytics/AnalyticsWrapper";
import SignIn from "./pages/AuthPages/SignIn";
import SignUp from "./pages/AuthPages/SignUp";
import VerifyEmail from "./pages/AuthPages/VerifyEmail";
import ForgetPassword from "./pages/AuthPages/ForgetPassword";
import ResetPassword from "./pages/AuthPages/ResetPassword";
import ImpersonateHandler from "./pages/AuthPages/ImpersonateHandler";
import NotFound from "./pages/OtherPage/NotFound";
import UserProfiles from "./pages/UserProfiles";
import AppLayout from "./layout/AppLayout";
import { ScrollToTop } from "./components/common/ScrollToTop";
import Onboarding from "./pages/Onboarding/Onboarding";
import Home from "./pages/Dashboard/Home";
import MyProducts from "./pages/Products/MyProducts";
import NewProduct from "./pages/Products/NewProduct";
import EditProduct from "./pages/Products/EditProduct";
import ViewProduct from "./pages/Products/ViewProduct";
import NewOffer from "./pages/Products/NewOffer";
import EditOffer from "./pages/Products/EditOffer";
import MySales from "./pages/Sales/MySales";
import MySubscriptions from "./pages/Subscriptions/MySubscriptions";
import MyAffiliates from "./pages/Affiliates/MyAffiliates";
import MyFinance from "./pages/Finance/MyFinance";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import NewCheckout from "./pages/Checkout-Builder/NewCheckoutBuilder";
import Checkout from "./pages/Checkout/Checkout";
import EditCheckoutBuilder from "./pages/Checkout-Builder/EditCheckoutBuilder";
import CheckoutBuilderPage from "./pages/Checkout-Builder/CheckoutBuilder";
import NewPixel from "./pages/Pixel/NewPixel";
import EditPixel from "./pages/Pixel/EditPixel";
import NewBump from "./pages/Bump/NewBump";
import EditBump from "./pages/Bump/EditBump";
import NewCoupon from "./pages/Coupon/NewCoupon";
import EditCoupon from "./pages/Coupon/EditCoupon";
import SalesDetailsPage from "./pages/Sales/SalesDetailPage";
import SubscriptionDetailsPage from "./pages/Subscriptions/SubscriptionsDetailPage";
import NewUpsell from "./pages/Upsell/NewUpsell";
import EditUpsell from "./pages/Upsell/EditUpsell";
import Apps from "./pages/Apps/Apps";
import Domains from "./pages/Apps/Domains/Domains";
import NewDomain from "./pages/Apps/Domains/NewDomain";
import Webhooks from "./pages/Apps/Webhooks/Webhooks";
import NewWebhook from "./pages/Apps/Webhooks/NewWebhook";
import EditWebhook from "./pages/Apps/Webhooks/EditWebhook";
import WebhooksLogs from "./pages/Apps/Webhooks/WebhooksLogs";
import Cademi from "./pages/Apps/Cademi/Cademi";
import NewCademi from "./pages/Apps/Cademi/NewCademi";
import EditCademi from "./pages/Apps/Cademi/EditCademi";
import NewTerm from "./pages/Terms/NewTerm";
import EditTerm from "./pages/Terms/EditTerm";
import NewCoproducer from "./pages/Co-Producer/NewCoproducer";
import NewAffiliate from "./pages/Affiliates/NewAffiliates";
import CompanyAffiliatesLinks from "./pages/Affiliates/CompanyAffiliatesLinks";
import FinalizationPix from "./pages/Pix/FinalizationPix";
import FinalizationBoleto from "./pages/Boleto/FinalizationBoleto";
import MySalesAbandoned from "./pages/SalesAbandoned/MySalesAbandoned";
import SalesAbandonedDetailsPage from "./pages/SalesAbandoned/SalesAbandonedDetailPage";
import Success from "./pages/Success/Success";
import Memberkit from "./pages/Apps/Memberkit/Memberkit";
import NewMemberkit from "./pages/Apps/Memberkit/NewMemberkit";
import Utmify from "./pages/Apps/Utmify/Utmify";
import NewUtmify from "./pages/Apps/Utmify/NewUtmify";
import EditUtmify from "./pages/Apps/Utmify/EditUtmify";
import Notazz from "./pages/Apps/Notazz/Notazz";
import Spedy from "./pages/Apps/Spedy/Spedy";
import TheMembers from "./pages/Apps/TheMembers/TheMembers";
import NewTheMembers from "./pages/Apps/TheMembers/NewTheMembers";
import EditTheMembers from "./pages/Apps/TheMembers/EditTheMembers";
import AstronMembers from "./pages/Apps/AstronMembers/AstronMembers";
import NewAstronMembers from "./pages/Apps/AstronMembers/NewAstronMembers";
import EditAstronMembers from "./pages/Apps/AstronMembers/EditAstronMembers";
import MyCollaborators from "./pages/Collaborators/MyCollaborators";
import InviteCollaborator from "./pages/Collaborators/InviteCollaborator";
import EditCollaborator from "./pages/Collaborators/EditCollaborator";
import ConfirmInvite from "./pages/AuthPages/ConfirmInvite";
import NoPermission from "./pages/OtherPage/NoPermission";
import { PermissionProtectedRoute } from "./components/auth/PermissionProtectedRoute";
import { FirstAvailableRedirect } from "./components/auth/FirstAvailableRedirect";
import CancelRenewal from "./pages/Subscriptions/CancelRenewal";
import SellyoMembersPage from "./pages/Apps/SellyoMembers/SellyoMembersPage";
import NewSellyoMembersPage from "./pages/Apps/SellyoMembers/NewSellyoMembersPage";
import EditSellyoMembersPage from "./pages/Apps/SellyoMembers/EditSellyoMembersPage";


export default function App() {
  return (
    <>
      <Router>
        <ScrollToTop />
        <AnalyticsWrapper>
          <ErrorBoundary>
            <Routes>
              {/* Rotas protegidas - Requer autenticação */}
              <Route element={<ProtectedRoute />}>
                <Route path="/onboarding" element={<Onboarding />} />
                <Route path="/checkout-builder" element={
                  <PermissionProtectedRoute permission="products.edit">
                    <CheckoutBuilderPage />
                  </PermissionProtectedRoute>
                } />
                <Route path="/checkout-builder/:id" element={
                  <PermissionProtectedRoute permission="products.edit">
                    <CheckoutBuilderPage />
                  </PermissionProtectedRoute>
                } />
                {/* Dashboard Layout */}
                <Route element={<AppLayout />}>
                  {/* Rota raiz - redireciona para primeira página disponível */}
                  <Route index path="/" element={<FirstAvailableRedirect />} />

                  {/* Dashboard */}
                  <Route path="/dashboard" element={
                    <PermissionProtectedRoute permission="dashboard.view">
                      <Home />
                    </PermissionProtectedRoute>
                  } />

                  {/* Vendas */}
                  <Route path="/sales" element={
                    <PermissionProtectedRoute permission="sales.view">
                      <MySales />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/sales/detail" element={
                    <PermissionProtectedRoute permission="sales.view">
                      <SalesDetailsPage />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/sales/:id" element={
                    <PermissionProtectedRoute permission="sales.view">
                      <SalesDetailsPage />
                    </PermissionProtectedRoute>
                  } />

                  {/* Abandonos */}
                  <Route path="/abandoned" element={
                    <PermissionProtectedRoute permission="sales.abandoned">
                      <MySalesAbandoned />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/abandoned/:id" element={
                    <PermissionProtectedRoute permission="sales.abandoned">
                      <SalesAbandonedDetailsPage />
                    </PermissionProtectedRoute>
                  } />

                  {/* Assinaturas */}
                  <Route path="/subscriptions" element={
                    <PermissionProtectedRoute permission="subscriptions.view">
                      <MySubscriptions />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/subscriptions/:id" element={
                    <PermissionProtectedRoute permission="subscriptions.view">
                      <SubscriptionDetailsPage />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/affiliates" element={<MyAffiliates />} />

                  {/* Produtos */}
                  <Route path="/products" element={
                    <PermissionProtectedRoute permission="products.view">
                      <MyProducts />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/products/new" element={
                    <PermissionProtectedRoute permission="products.edit">
                      <NewProduct />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/products/edit/:id" element={
                    <PermissionProtectedRoute permission="products.edit">
                      <EditProduct />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/products/view/:id" element={
                    <PermissionProtectedRoute permission="products.view">
                      <ViewProduct />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/products/edit/:productId/offer/:offerId" element={
                    <PermissionProtectedRoute permission="products.edit">
                      <EditOffer />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/products/:productId/new-pixel" element={
                    <PermissionProtectedRoute permission="products.edit">
                      <NewPixel />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/products/edit/:productId/pixel/:pixelId" element={
                    <PermissionProtectedRoute permission="products.edit">
                      <EditPixel />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/products/terms/new" element={
                    <PermissionProtectedRoute permission="products.edit">
                      <NewTerm />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/products/terms/edit/:id" element={
                    <PermissionProtectedRoute permission="products.edit">
                      <EditTerm />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/products/:productId/new-offer" element={
                    <PermissionProtectedRoute permission="products.edit">
                      <NewOffer />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/products/:productId/new-bump" element={
                    <PermissionProtectedRoute permission="products.edit">
                      <NewBump />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/products/:productId/new-checkout" element={
                    <PermissionProtectedRoute permission="products.edit">
                      <NewCheckout />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/products/:productId/edit-checkout/:checkoutId" element={
                    <PermissionProtectedRoute permission="products.edit">
                      <EditCheckoutBuilder />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/products/edit/:productId/bump/:bumpId" element={
                    <PermissionProtectedRoute permission="products.edit">
                      <EditBump />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/products/:productId/new-coupon" element={
                    <PermissionProtectedRoute permission="products.edit">
                      <NewCoupon />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/products/edit/:productId/coupon/:couponId" element={
                    <PermissionProtectedRoute permission="products.edit">
                      <EditCoupon />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/products/:productId/new-upsell" element={
                    <PermissionProtectedRoute permission="products.edit">
                      <NewUpsell />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/products/edit/:productId/upsell/:upsellId" element={
                    <PermissionProtectedRoute permission="products.edit">
                      <EditUpsell />
                    </PermissionProtectedRoute>
                  } />

                  {/* Financeiro */}
                  <Route path="/finance" element={
                    <PermissionProtectedRoute permission="financial.view">
                      <MyFinance />
                    </PermissionProtectedRoute>
                  } />
                  {/* Integrações */}
                  <Route path="/apps" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <Apps />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/domains" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <Domains />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/domains/new" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <NewDomain />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/webhooks" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <Webhooks />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/webhooks/new-webhook" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <NewWebhook />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/cademi" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <Cademi />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/cademi/new-cademi" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <NewCademi />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/cademi/edit/:cademiId" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <EditCademi />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/notazz" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <Notazz />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/spedy" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <Spedy />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/utmify" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <Utmify />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/utmify/new-utmify" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <NewUtmify />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/utmify/edit/:integrationId" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <EditUtmify />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/memberkit" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <Memberkit />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/memberkit/new-memberkit" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <NewMemberkit />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/webhooks/edit/:webhookId" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <EditWebhook />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/webhooks/:webhookId/events" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <WebhooksLogs />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/products/:productId/co-producer/new" element={<NewCoproducer />} />
                  <Route path="/products/:productId/affiliates/new" element={<NewAffiliate />} />
                  <Route path="/products/affiliate/:productId/links" element={<CompanyAffiliatesLinks />} />
                  <Route path="/apps/themembers" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <TheMembers />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/themembers/new-themembers" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <NewTheMembers />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/themembers/edit/:themembersId" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <EditTheMembers />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/astronmembers" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <AstronMembers />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/astronmembers/new-astronmembers" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <NewAstronMembers />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/astronmembers/edit/:astronmembersId" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <EditAstronMembers />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/sellyo-members" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <SellyoMembersPage />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/sellyo-members/new" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <NewSellyoMembersPage />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/apps/sellyo-members/edit/:id" element={
                    <PermissionProtectedRoute permission="integrations.full">
                      <EditSellyoMembersPage />
                    </PermissionProtectedRoute>
                  } />

                  {/* Colaboradores */}
                  <Route path="/collaborators" element={
                    <PermissionProtectedRoute permission="collaborators.manage">
                      <MyCollaborators />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/collaborators/invite" element={
                    <PermissionProtectedRoute permission="collaborators.manage">
                      <InviteCollaborator />
                    </PermissionProtectedRoute>
                  } />
                  <Route path="/collaborators/:id/edit" element={
                    <PermissionProtectedRoute permission="collaborators.manage">
                      <EditCollaborator />
                    </PermissionProtectedRoute>
                  } />
                  {/* Others Page */}
                  <Route path="/profile" element={<UserProfiles />} />
                </Route>
              </Route>

              {/* Rotas públicas - Não requerem autenticação */}
              <Route path="/p/:id" element={<Checkout />} />
              <Route path="/finalization-pix/:id" element={<FinalizationPix />} />
              <Route path="/finalization-boleto/:id" element={<FinalizationBoleto />} />
              <Route path="/auth/impersonate" element={<ImpersonateHandler />} />
              <Route path="/signin" element={<SignIn />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/forget-password" element={<ForgetPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/team-invite/:token" element={<ConfirmInvite />} />
              <Route path="/assinatura/cancelar" element={<CancelRenewal />} />
              <Route path="/no-permission" element={<NoPermission />} />
              <Route path="/success/:id" element={<Success />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </ErrorBoundary>
        </AnalyticsWrapper>
      </Router>
    </>
  );
}
